import { Cart, nativeAppHeaders } from '@ynap/api-utils'
import { delay } from '@ynap/promise-utils'
import { raygun } from '@ynap/clientside-monitoring'
import { getWatsonConfig, getTimeout, getDelay } from '@ynap/cart-state/src/selectors/getConfig'
import { getCurrentBillingAddress, getCurrentPaymentOption } from '../selectors/getPaymentStep'
import wrapFetchWithJSON from './common/wrapFetchWithJSON'

import { setPaymentMethodRequest, setPaymentMethodSuccess, setPaymentMethodError } from './setPaymentMethod'
import { getLocale } from '@ynap/cart-state'
import { collectBrowserInfo } from '../../../adyen'
import { getAdditionalCheckoutHeaders } from '../utils/checkoutActionUtils'

export default function updatePaymentMethod(params) {
    return (dispatch, getState, fetch) => {
        const state = getState()
        const watsonConfig = getWatsonConfig(state)
        const fetchJSON = wrapFetchWithJSON(fetch, getTimeout(state))
        const currentBillingAddress = getCurrentBillingAddress(state)
        const currentPaymentOption = getCurrentPaymentOption(state)
        // SHOP-1604: Collect info on failed /checkout/authorise
        if (!currentBillingAddress || !currentPaymentOption) {
            const error = new Error('Missing required currentBillingAddress or currentPaymentOption')
            raygun.helpers.agent('send', {
                error,
                tags: ['Authorise', 'updatePaymentMethod'],
                customData: {
                    orderId: state?.cart?.orderId,
                    buyerId: state?.cart?.x_buyerId,
                },
            })
            // Could bail out here for cleaner handling instead of TypeError
            // return dispatch(setPaymentMethodError(error))
        }
        const { langId } = getLocale(state)
        const additionalHeaders = {
            ...nativeAppHeaders(state.deviceType),
            ...getAdditionalCheckoutHeaders(state),
        }
        const [paymentMethodId, cardId] = currentPaymentOption?.id?.split('/') || []
        const paymentSystem = state?.cart?.x_paymentSystem
        const isPaypal = !cardId // Could be paymentMethodId === 'PAYPAL'?
        dispatch(setPaymentMethodRequest())

        const getPaymentTokens = () => {
            if (params.id === 'APPLEPAY') {
                return {
                    payMethodId: params.id,
                    'params.1.name': 'validationUrl',
                    'params.1.value': params.validationUrl,
                }
            }
            if (params.id === 'APPLEPAYUPDATE') {
                return {
                    payMethodId: 'APPLEPAY',
                    apiToken: params.token,
                    cc_lastFourDigits: params.lastFourDigits,
                }
            }
            if (isPaypal) {
                return mapParams(params, paymentSystem, null, paymentMethodId)
            } else if (params.type === '3ds2') {
                // sending values in both params.1 and params.3 as spec says .3 but WCS expects .1
                return {
                    token: params.token,
                    ...params.browserInfo,
                    'params.1.name': 'tokenType',
                    'params.1.value': params.tokenType,
                    'params.3.name': 'tokenType',
                    'params.3.value': params.tokenType,
                }
            } else {
                return mapParams({ PaRes: params.PaRes, MD: params.MD }, paymentSystem, params.PaRes)
            }
        }
        const browserInfo = collectBrowserInfo()
        const promise = fetchJSON(
            Cart.setPaymentInstruction({
                paymentInstruction: [
                    {
                        payMethodId: paymentMethodId,
                        billing_address_id: currentBillingAddress?.addressId,
                        ...getPaymentTokens(),
                        ...browserInfo,
                    },
                ],
                clearExisting: 'false',
                ...watsonConfig,
                langId,
                additionalHeaders,
            })
        )

        return delay(promise, getDelay(state))
            .then((data) => {
                dispatch(setPaymentMethodSuccess(data))
                return data
            })
            .catch((error) => {
                dispatch(setPaymentMethodError(error))
                throw error
            })
    }
}

function mapParams(values, paymentSystem, PaRes, paymentMethodId) {
    //todo this can be cleaned up once GPS have moved to only support the new paypal flow
    if (paymentSystem === 'GPS' && paymentMethodId === 'PAYPAL' && values.PayerID && values.token) {
        return {
            //todo only send PayerID until WCS have fixed the issue where sending the token too causes a error, neither are required by GPS
            'params.1.name': 'PayerID',
            'params.1.value': values.PayerID,
        }
    }

    const obj = {}
    let i = 1
    for (let key in values) {
        obj[`params.${i}.name`] = key
        obj[`params.${i}.value`] = encodeURIComponent(values[key])
        i++
    }
    PaRes ? (obj.gateway_transaction_token = PaRes) : null
    return obj
}
